export const ONE_FOOTBALL_TV_FAQ_URL = "https://tv-app.onefootball.com";
